<template>
<div>
    <alert v-model="notify.show" :errorType="notify.type" :message="notify.message" />
    <container class="mt-8  py-8">
	<p>Victor2</p>
        <h6 v-if="getLearnerLesson.completed" class="mb-4 font-bold text-lg">
            You have already answered this quiz
        </h6>
        <div v-if="!getLearnerLesson.completed" class="quiz">
            <p class="float-right font-bold ">{{currentIndex + 1}}/{{quiz.questions.slice(0,slicedLength).length}}</p>

            <div class="description mb-4">
                <h6 class="mb-4 font-bold text-lg">{{ quiz.title }}</h6>
                <!-- <div>{{ parseInt(quiz.total_quiz_mark) }} marks</div> -->
            </div>
            <div>
                <div class="question mb-8">

                    <div class="question-head mb-4 flex justify-between font-black">
                        <!--                        <h6>Question {{ currentIndex + 1 }}</h6>-->
                        <!-- <span>{{ parseInt(quiz.questions[currentIndex].score )}} marks</span> -->
                    </div>
                    <div class="mb-4">
                        <p v-html="quiz.questions[currentIndex].question_text">

                        </p>
                    </div>
                    <div class="flex flex-col options">
                        <span v-for="(option, x) in quiz.questions[currentIndex].options" :key="x" class="mb-4">
                            <input v-model="answers[currentIndex]" :id="x" type="radio" :name="option + quiz.questions[currentIndex].question_text" :value="x" :disabled="showAnswers || getLearnerLesson.completed" />
                            <label class="ml-2">{{ option }} </label>
                            <span v-if="showAnswers">
                                <label v-if="answers[currentIndex] == quiz.questions[currentIndex].answer && answers[currentIndex] == x" class="ml-2 text-green-500">Correct</label>
                                <label v-else-if="
                      answers[currentIndex] !== question.answer && answers[currentIndex] == x
                    " class="ml-2 text-red-500">Wrong</label>
                                <label v-else-if="
                      answers[currentIndex] !== quiz.questions[currentIndex].answer && quiz.questions[currentIndex].answer == x
                    " class="ml-2 text-green-500">This is the correct answer</label>
                            </span>
                        </span>
                    </div>
                </div>
                <div v-if="!getLearnerLesson.completed" class="w-full flex justify-center">
                    <lms-button class="float-left mr-5" v-if="currentIndex !== 0" @click="showPrevious(currentIndex)">Previous Question</lms-button>
                    <lms-button v-if="!getLearnerLesson.completed && quiz.questions.slice(0,slicedLength).length === currentIndex + 1 " @click.stop="popConfirm">{{ submitText }}</lms-button>
                    <lms-button class="float-right ml-10" v-if=" quiz.questions.slice(0,slicedLength).length !== currentIndex + 1" @click="showNext(currentIndex)">Next Question</lms-button>
                </div>
            </div>
        </div>

        <div v-else class="quiz">
            <div class="description mb-4">
                <h6 class="mb-4 font-bold text-lg">{{ quiz.title }}</h6>
                <!-- <div>{{ parseInt(quiz.total_quiz_mark )}} marks</div> -->
            </div>
            <div>
                <div v-if="typeof question.user_value !== 'undefined'" v-for="(question, i) in JSON.parse(submitted_answer)" :key="i" class="question mb-8">
                    <div class="question-head mb-4 flex justify-between font-black">
                        <h6>Question {{ i + 1 }}</h6>
                        <!-- <span>{{ parseInt(question.score) }} marks</span> -->
                    </div>
                    <div class="mb-4">
                        <p>
                            {{ question.question_text }}
                        </p>
                    </div>
                    <div class="flex flex-col options">
                        <span v-for="(option, x) in JSON.parse(question.options)" :key="x" class="mb-4">
                            <input v-model="question.user_value" :id="x" type="radio" :name="option" :value="JSON.parse(question.options)[x]" disabled />
                            <label class="ml-2">{{ option }} </label>

                            <label v-if="
                    question.user_value == question.answer &&
                      question.user_value == JSON.parse(question.options)[x]
                  " class="ml-2 text-green-500">Correct</label>
                            <label v-else-if="
                    question.user_value !== question.answer &&
                      question.user_value == JSON.parse(question.options)[x]
                  " class="ml-2 text-red-500">Wrong</label>
                            <label v-else-if="
                    question.user_value !== question.answer &&
                      question.answer == JSON.parse(question.options)[x]
                  " class="ml-2 text-green-500">This is the correct answer</label>
                        </span>
                    </div>
                </div>
                <div v-if="!getLearnerLesson.completed" class="w-full flex justify-center">
                    <lms-button v-if="!getLearnerLesson.completed || !showAnswers" @click.stop="markQuiz">Submit Quiz</lms-button>
                </div>
            </div>
        </div>
    </container>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
export default {
    props: ["quiz", "submitted_answer"],
    computed: {
        ...mapGetters(["getUser", "getLearnerLesson"]),
    },
    methods: {
        
        popConfirm() {
            this.$confirm({
                message: `Hi ${this.getUser.first_name}. Are you sure you're ready to submit your ${this.quiz.title} Quiz? You would not be able to make any changes after. Proceed?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },

                callback: (confirm) => {
                    if (confirm) {
                        this.submitText = 'submitting...please wait!';
                        this.markQuiz();
                    }
                },
            });
        },
        ...mapActions(["learnerSubmitQuiz","completeLesson"]),
          ...mapMutations(["updateLoader"]),
        handleNotify(payload) {
            this.notify.show = true;
            this.notify.type = payload.type;
            this.notify.message = payload.message;
        },
        shuffle(array) {
            var currentIndex = array.length,
                temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        },
        async markQuiz() {
            this.updateLoader(true)
            let answer = [];
            this.showAnswers = true;
            for (let i = 0; i < this.quiz.questions.length; i++) {
                let data = {
                    id: this.quiz.questions[i].id,
                    quiz_id: this.quiz.id,
                    tenant_id: this.getUser.tenant.id,
                    question_text: this.quiz.questions[i].question_text,
                    score: this.quiz.questions[i].score,
                    options: JSON.stringify(this.quiz.questions[i].options),
                    answer: this.quiz.questions[i].options[this.quiz.questions[i].answer],
                    user_value: this.quiz.questions[i].options[this.answers[i]],
                };
                answer.push(data);
                if (this.answers[i] == this.quiz.questions[i].answer) {
                    this.score += parseInt(this.quiz.questions[i].score);

                }
            }
            this.submitText = 'still submitting...please wait!';
            let res = await this.learnerSubmitQuiz({
                id: this.$route.params.lesson_id,
                data: {
                    score: parseInt(this.score),
                    answer,
                },
            });
            if (res == true || res.status == 200 || res.status == 201) {
                this.submitText = 'submitted! Loading next lesson...';
                this.form = {};
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Quiz taken successfully",
                });
                this.updateLoader(false)
                this.$emit('quiz-submitted', 'someValue')
                // let res = await this.completeLesson({
                //   id: this.$route.params.lesson_id
                // });
               //      if(res.status){
               //     this.updateLoader(false)
               //     location.reload();
               //
               // }
               this.updateLoader(false)

                // this.$Bus.$emit("submit-resource", {});
            } else {
                 this.updateLoader(false)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
        showNext(index) {
            this.currentIndex++

        },
        showPrevious(index) {
            this.currentIndex--;

        },
    },
    data() {
        return {
            answers: [],
            showAnswers: false,
            score: 0,
            alert: false,
            notify: {
                type: null,
                show: false,
                message: "",
            },
            currentIndex: 0,
            slicedLength: 15,
            submitText: "Submit Quiz"
        };
    },
    mounted() {
	console.log(this.getLearnerLesson);
	console.log(this.getLearnerLesson());
        this.$Bus.$on("notify", (data) => {
            this.notify.show = true;
            this.notify.type = data.type;
            this.notify.message = data.message;
        });
    },
    created() {
        this.quiz.questions = this.shuffle(this.quiz.questions)
    },
    components: {
        container: () => import("@/components/general/container"),
        LmsButton: () => import("@/components/general/button"),
        Alert: () => import("@/components/tenant/alert"),
    },
};
</script>

<style lang="scss" scoped>
.quiz {
    .navs {
        color: color(lms-tenant);
    }

    .description {
        h6 {
            color: color(lms-tenant);
        }
    }

    .question-head {
        color: color(lms-tenant);
    }
}
</style>
